// extracted by mini-css-extract-plugin
export default {"container":"fullScreenLoader__container__v19gc","show":"fullScreenLoader__show__dsMov","ticket":"fullScreenLoader__ticket__QbuQF","slowSpin":"fullScreenLoader__slowSpin__j5j48"};